import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map'; // add map function to observable
import 'rxjs/add/operator/catch';

import { environment } from '../../environments/environment';
import { AuthenticationService } from '../services';
import * as FileSaver from 'file-saver';

@Injectable()
export class StorageService {

    private containerURL = environment.storageURL + 'container';

    constructor(
        private http: Http,
        private authenticationService: AuthenticationService) {
    }


    getStorages(token: string) {
        var headers = this.authenticationService.getHeaderByToken(token);

        return this.http.get(this.containerURL + '/storages/allowed', {
            headers: headers
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {

            return Observable.throw(new Error("Could not get storages"));
        });
    }

    updateContainer(container: any, update: boolean) {
        let filter: string = '?update=' + update;
        container.storage = this.authenticationService.getStorageName();
        return this.http.put(this.containerURL + filter, container, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {

            return Observable.throw(new Error("Could not create container"));
        });
    }

    getContainers(containerType: string) {
        let filter: string = '?containerType=' + containerType + '&storageName=' + this.authenticationService.getStorageName()
        return this.http.get(this.containerURL + filter, {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get containers"));
        });
    }

    getContainerLabel(containerName: string) {
        return this.http.get(this.containerURL + '/label/' + containerName + '?storageName=' + this.authenticationService.getStorageName(), 
            {
                headers: this.authenticationService.getHeaderPDF(),
                responseType: ResponseContentType.Blob
            })
           .map((res: Response) => {
                let fileBlob = res.blob();
                let blob = new Blob([fileBlob], { 
                    type: 'application/pdf' // must match the Accept type
                });
                let filename = containerName+'.pdf';
                FileSaver.saveAs(blob, filename); 
                return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get container label"));
        });
    }

    getContainer(containerName: string) {
        return this.http.get(this.containerURL + '/' + containerName + '?storageName=' + this.authenticationService.getStorageName(), {
            headers: this.authenticationService.getHeader()
        })
        .map((res: Response) => {
            return res.json();
        })
        .catch((error: any) => {
            return Observable.throw(new Error("Could not get container!"));
        });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/services/storage.service.ts